import { render, staticRenderFns } from "./create-project.vue?vue&type=template&id=6a9582d2"
import script from "./create-project.vue?vue&type=script&lang=js"
export * from "./create-project.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports